module.exports = __webpack_public_path__ + "static/img/xingHalf.aea1d3d4.svg";